const en = {
  translation: {
    // Reports module (fleet-api reports/: catalog, runs, exports, schedules)
    reports: {
      windowTitle: "Reports",
      tabRun: "Run a report",
      tabSchedules: "Scheduled emails",
      catalogFailed: "The report catalog could not be loaded.",
      disabled: "Reports are switched off for this account. An administrator can enable them in Settings.",
      scope: "Scope",
      scopeCustomer: "Whole account",
      scopeFleet: "One fleet",
      scopeVehicle: "One vehicle",
      scopeDriver: "One driver",
      fleet: "Fleet",
      vehicle: "Vehicle",
      driver: "Driver",
      customer: "Customer",
      corridor: "Corridor",
      choose: "Choose…",
      searchFleet: "Search a fleet…",
      searchVehicle: "Search a vehicle or plate…",
      searchDriver: "Search a driver…",
      searchCustomer: "Search a customer…",
      searchCorridor: "Search a corridor…",
      noMatch: "No match",
      noDrivers: "No active driver yet",
      allCustomers: "All customers",
      corridorAny: "Anywhere (no corridor)",
      corridorHint: "Only the positions recorded inside this corridor will be counted.",
      corridorWidthKm: "± {{width}} km",
      driverHint: "Covers only the periods this driver held the vehicle.",
      copyReference: "Copy this report reference",
      copyFailed: "The reference could not be copied",
      format: {
        pdf: "PDF report",
        xlsx: "Excel workbook",
        csv: "CSV data"
      },
      periodLabel: "Period",
      periods: {
        TODAY: "Today",
        YESTERDAY: "Yesterday",
        LAST_7_DAYS: "Last 7 days",
        LAST_30_DAYS: "Last 30 days",
        THIS_MONTH: "This month",
        LAST_MONTH: "Last month",
        CUSTOM: "Custom dates"
      },
      from: "From",
      to: "To",
      fromTimeHint: "Start time (empty: from midnight)",
      toTimeHint: "End time (empty: until the end of the day)",
      run: "Run report",
      runFailed: "The report could not be produced.",
      paramsHint: "Thresholds start from your account settings and can be changed per run.",
      exportReady: "{{format}} file downloaded.",
      exportFailed: "The export could not be produced.",
      rangeLabel: "Period covered",
      rowCount: "Rows",
      vehicleCount: "{{count}} vehicle",
      vehicleCount_plural: "{{count}} vehicles",
      truncated: "The period holds more telemetry than one run can read; narrow the dates for a complete picture.",
      noRows: "Nothing to report for this period.",
      chartTitle: "Top {{count}} vehicles",
      noticesTitle: "Vehicles that could not be measured",
      missingSignals: "Needs {{signals}}",
      signalWarning: "No tracker in this account reports {{signals}}, so this report will be empty until such a device is fitted.",
      signal: {
        gps: "position",
        speed: "speed",
        ignition: "ignition",
        odometer: "odometer",
        fuel: "fuel level",
        temperature: "temperature"
      },
      notice: {
        NO_GPS: "its tracker does not report position",
        NO_SPEED: "its tracker does not report speed",
        NO_IGNITION: "its tracker does not report ignition",
        NO_IGNITION_IN_RANGE: "no ignition reading in this period",
        NO_DATA_IN_RANGE: "no telemetry in this period",
        COUNTRY_NOT_RESOLVED: "its positions have not been matched to a country yet",
        NO_CONSUMPTION_CONFIGURED: "no average consumption recorded for this vehicle",
        UNKNOWN_FUEL_TYPE: "its fuel type is unknown, so CO2 cannot be derived",
        OUTSIDE_CORRIDOR: "it sent no position inside the selected corridor"
      },
      chart: {
        distanceKm: "Distance (km)",
        stoppedMinutes: "Time stopped (min)",
        wastedMinutes: "Wasted engine time (min)",
        peakKmh: "Peak speed (km/h)",
        averageKmh: "Average speed (km/h)",
        events: "Occurrences",
        minutesOverLimit: "Minutes over limit",
        productiveHours: "Productive hours",
        idleHours: "Idling hours",
        crossings: "Crossings",
        co2Kg: "CO2 (kg)",
        daysEmitted: "Days with data",
        daysSilent: "Days without data"
      },
      summary: {
        trips: "Trips",
        stops: "Stops",
        periods: "Idling periods",
        events: "Occurrences",
        crossings: "Crossings",
        vehicles: "Vehicles",
        countries_visited: "Countries visited",
        total_distance_km: "Total distance (km)",
        total_duration_minutes: "Total duration",
        total_stopped_minutes: "Time stopped",
        total_wasted_minutes: "Wasted engine time",
        wasted_share_percent: "Share of stops wasted (%)",
        total_minutes_over_limit: "Time over limit",
        worst_peak_speed_kmh: "Worst peak speed (km/h)",
        fleet_peak_speed_kmh: "Fleet peak speed (km/h)",
        fleet_average_speed_kmh: "Fleet average speed (km/h)",
        total_gps_distance_km: "Total GPS distance (km)",
        total_engine_hours: "Total engine hours",
        total_idle_hours: "Total idling hours",
        total_fuel_litres: "Fuel burned (L)",
        total_co2_kg: "CO2 (kg)",
        days: "Days in the period",
        vehicle_days_emitted: "Vehicle-days with data",
        vehicle_days_silent: "Vehicle-days without data",
        vehicles_silent_whole_period: "Vehicles silent all period"
      },
      weekday: {
        "0": "Sunday",
        "1": "Monday",
        "2": "Tuesday",
        "3": "Wednesday",
        "4": "Thursday",
        "5": "Friday",
        "6": "Saturday"
      },
      schedules: {
        title: "Scheduled report emails",
        subtitle: "Choose the reports, the recipients and when they go out. Files are attached in the formats you pick.",
        new: "New schedule",
        newTitle: "New schedule",
        editTitle: "Edit schedule",
        emptyTitle: "No scheduled reports yet",
        emptyHint: "Create one to have reports arrive by email without anyone opening the portal.",
        name: "Name",
        subject: "Email subject",
        reports: "Reports to attach",
        formats: "Attach as",
        pickFormat: "Pick at least one file format.",
        frequency: "Frequency",
        daily: "Every day",
        weekly: "Every week",
        monthly: "Every month",
        weekday: "Day of the week",
        dayOfMonth: "Day of the month",
        weekdays: "Days of the week",
        daysOfMonth: "Days of the month",
        daysOfMonthHint: "Up to the 28th, so the report also goes out in February.",
        groupedSend: "Grouped send",
        groupedSendOn: "one mail to all addresses; recipients see each other.",
        groupedSendOff: "one separate mail per address.",
        sendTime: "Send at",
        timezone: "Timezone (of the send time)",
        mailLanguage: "Email language",
        recipients: "Recipients",
        body: "Message",
        bodyPlaceholder: "Optional text added above the report summary.",
        active: "Schedule is active",
        nextRun: "Next send",
        sendNow: "Send now",
        history: "Send history",
        scheduledFor: "Scheduled for",
        detail: "Detail",
        noRuns: "This schedule has not sent anything yet.",
        saved: "Schedule saved.",
        saveFailed: "The schedule could not be saved.",
        deleted: "Schedule deleted.",
        deleteFailed: "The schedule could not be deleted.",
        deleteConfirm: "Delete the schedule \"{{name}}\"?",
        sent: "Report sent.",
        sentTo: "Report sent to {{count}} recipient.",
        sentTo_plural: "Report sent to {{count}} recipients.",
        skippedNoRecipient: "Nothing was sent: no usable recipient address.",
        sendFailed: "The report could not be sent.",
        sendFailedCode: "The report could not be sent ({{code}})."
      }
    },
    // Map warnings panel
    warnings: "Warnings",
    warning_silent: "{{name}} has no signal",
    warning_battery: "{{name}}: battery at {{level}}%",
    warning_battery_hint: "Tracker battery low",
    last_position: "Last position",
    hours_ago: "{{count}} h ago",
    days_ago: "{{count}} days ago",
    trajectory: "Trajectory",
    // Common
    save: "Save",
    cancel: "Cancel",
    delete: "Delete",
    close: "Close",
    edit: "Edit",
    create: "Create",
    update: "Update",
    confirm: "Confirm",
    back: "Back",
    next: "Next",
    search: "Search",
    loading: "Loading...",
    retry: "Retry",
    enabled: "Enabled",
    disabled: "Disabled",
    vcc_loading: "Loading control center…",
    vcc_title: "Vehicle Control Center",
    vcc_load_failed: "Unable to load the vehicle control center.",
    vcc_geofences: "Geofences",
    vcc_corridors: "Corridors",
    vcc_open_tab: "Open the matching tab",
    vcc_enabled_rules: "Enabled rules",
    vcc_open_alerts: "Open alerts",
    vcc_waiting_tracker: "Configured — waiting for tracker. Zones and rules are ready, but no tracker is currently reporting.",
    vcc_tracking_assignment: "Tracking & Assignment",
    vcc_zones_routes: "Zones & Routes",
    vcc_zones_hint: "Effective direct and inherited monitoring areas for this vehicle.",
    vcc_alert_rules: "Alert Rules",
    vcc_rules_hint: "Direct and inherited rules that are effective for this vehicle.",
    vcc_vehicle_alerts: "Vehicle Alerts",
    vcc_alerts_hint: "Review and act on alerts raised for this vehicle.",
    vcc_attach_geofence: "Attach geofence",
    vcc_attach_corridor: "Attach corridor",
    vcc_create_geofence: "Create geofence",
    vcc_create_corridor: "Create corridor",
    vcc_attach_existing: "Attach existing {{type}}",
    vcc_attach: "Attach",
    vcc_create_rules: "Create monitoring rules",
    vcc_triggers: "Triggers",
    vcc_rules: "Rules",
    vcc_manage_source: "Manage this association at its fleet, mission, or tracker source.",
    vcc_manage_zone: "Open and manage zone",
    vcc_detach: "Detach from vehicle",
    vcc_detach_confirm: "Detach \"{{name}}\" from this vehicle? The zone geometry will not be deleted.",
    vcc_no_zones: "No zones or routes apply to this vehicle",
    vcc_no_zones_hint: "Attach an existing area or create one from the fleet map.",
    vcc_no_available_zones: "No available zones found",
    vcc_zone_options_failed: "Could not load available zones",
    vcc_zone_attached: "Zone attached to vehicle",
    vcc_zone_attach_failed: "Failed to attach zone",
    vcc_zone_detached: "Zone detached from vehicle",
    vcc_zone_detach_failed: "Failed to detach zone",
    vcc_create_rule: "Create rule",
    vcc_create_first_rule: "Create the first rule",
    vcc_no_rules: "No alert rules apply to this vehicle",
    vcc_rule_updated: "Alert rule updated",
    vcc_rule_update_failed: "Failed to update alert rule",
    vcc_manage_rule_source: "Inherited rules must be managed at their source",
    vcc_inherited_rule_hint: "Manage at source",
    vcc_trigger: "Trigger",
    vcc_zone: "Zone",
    vcc_channels: "Channels",
    vcc_recipients: "Recipients",
    vcc_schedule: "Schedule",
    vcc_always: "Always",
    vcc_position_required: "This vehicle has no recorded position. Assign a reporting tracker before creating a zone from its location.",
    vcc_active_missions: "Active missions",
    vcc_open_mission: "Open mission management",
    vcc_no_active_alerts: "No active alerts for this vehicle",
    vcc_no_alert_history: "No resolved alert history",
    vcc_acknowledge: "Acknowledge",
    vcc_resolve: "Resolve",
    vcc_alert_acknowledged: "Alert acknowledged",
    vcc_alert_resolved: "Alert resolved",
    vcc_alert_action_failed: "Alert action failed",
    id: "ID",
    speed: "Speed",
    show_route: "Show route",
    register_position: "Register position",
    create_geofence_here: "Create geofence here",
    start_route_here: "Start route here",
    trajectory_markers: "Markers",
    journey_start: "Journey start",
    journey_end: "Arrival / end of period",
    device_event: "Vehicle event",
    device_alert: "Vehicle alert",
    stop: "Stop",
    parking: "Parking",
    parking_5h: "Parking (5h+)",
    current_position: "Current position",
    more_events: "more events",
    events_at_this_position: "events at this position",
    toggle_device_events_hint: "Show or hide vehicle events on the route",
    toggle_device_alerts_hint: "Show or hide vehicle alerts and triggered rules on the route",
    toggle_stops_hint: "Show or hide stops on the route",
    toggle_parking_hint: "Show or hide long parking events on the route",
    map: "Map",
    stops: "Stops",
    stats: "Stats",
    stop_analysis: "Stop analysis",
    interactive_timeline: "Interactive timeline",
    restart_replay: "Restart replay",
    previous_point: "Previous point",
    play_replay: "Play replay",
    pause_replay: "Pause replay",
    next_point: "Next point",
    trajectory_timeline: "Trajectory timeline",
    replay_speed: "Replay speed",
    no_data: "No data",
    detailed_statistics: "Detailed statistics",
    distance: "Distance",
    trip_duration: "Trip duration",
    average_speed: "Average speed",
    maximum_speed: "Maximum speed",
    speed_p95: "95th percentile speed",
    moving_time: "Moving time",
    stopped_time: "Stopped time",
    detected_stops: "Detected stops",
    gps_points: "GPS points",
    itinerary: "Itinerary",
    history: "History",
    live_route_refresh_hint: "Live route refreshes automatically",
    error: "Error",
    success: "Success",
    warning: "Warning",
    active: "Active",
    inactive: "Inactive",
    yes: "Yes",
    no: "No",
    none: "None",
    unknown: "Unknown",
    all: "All",
    select: "Select",
    remove: "Remove",
    add: "Add",
    done: "Done",
    reset: "Reset",
    apply: "Apply",
    total: "Total",
    filtered: "Filtered",
    actions: "Actions",
    details: "Details",
    description: "Description",
    name: "Name",
    type: "Type",
    status: "Status",
    priority: "Priority",
    notes: "Notes",
    required: "Required",
    optional: "Optional",
    not_provided: "Not provided",
    none_assigned: "None assigned",
    no_results: "No results found",
    select_all: "Select All",
    clear_all: "Clear All",
    confirmation: "Confirmation",
    action_cannot_undone: "This action cannot be undone.",
    minimize: "Minimize",
    maximize: "Maximize",

    // Units
    kmh: "km/h",
    degrees: "°",
    percent: "%",
    celsius: "°C",
    km: "km",
    m: "m",
    hours: "h",
    minutes: "min",
    years: "years",
    points: "pts",
    devices: "device(s)",

    // Header
    fleet_portal: "SiniFleet",
    professional_fleet_management: "Professional Fleet Management",
    search_placeholder: "Search vehicle, driver...",
    live: "Live",
    paused: "Paused",
    last_update: "Last update",
    vehicles: "Vehicles",
    in_movement: "Moving",
    stopped_count: "Stopped",
    no_connection: "Offline",

    // Login
    login_title: "SiniFleet",
    login_subtitle: "Professional Fleet Management System",
    login_window_title: "SiniFleet Login",
    username: "Username",
    password: "Password",
    username_placeholder: "Enter your username",
    password_placeholder: "Enter your password",
    sign_in: "Sign In",
    signing_in: "Signing in...",
    remember_me: "Remember me",
    forgot_password: "Forgot password?",
    login_error: "An unexpected error occurred",
    login_failed: "Login failed",
    login_copyright: "© 2025 SiniFleet - Professional Fleet Management",
    welcome_back: "Welcome back",
    login_description: "Sign in to access your fleet management dashboard",
    secure_access: "Secure access",
    secure_access_desc: "Multi-factor protection for every account",
    fleet_operations: "Fleet operations",
    fleet_operations_desc: "Tracking, missions, alerts and administration",
    mfa_setup_title: "Set up your authenticator",
    mfa_setup_description: "Scan the QR code in your authenticator app, then enter its verification code.",
    mfa_qr_alt: "Authenticator setup QR code",
    mfa_manual_secret: "Manual setup key",
    mfa_authenticator_code: "Authenticator code",
    mfa_confirm_setup: "Confirm two-factor setup",
    mfa_choose_title: "Choose your two-factor method",
    mfa_choose_description: "Select how you want to receive verification codes when signing in.",
    mfa_choose_totp_description: "Use Microsoft Authenticator, Google Authenticator, or another compatible app.",
    mfa_choose_email_description: "Receive a single-use code at your verified email address.",
    mfa_verify_title: "Verify your identity",
    mfa_verify_description: "Use your authenticator, an email code, or a saved recovery code.",
    mfa_method_totp: "Authenticator",
    mfa_method_email: "Email",
    mfa_method_recovery: "Recovery",
    mfa_email_sent: "A verification code was sent to your email address.",
    mfa_email_send_failed: "The email code could not be sent.",
    mfa_email_resend: "Resend code",
    mfa_recovery_code: "Recovery code",
    mfa_verification_code: "Verification code",
    mfa_verify_action: "Verify and sign in",
    mfa_back_to_login: "Back to sign-in",
    mfa_recovery_title: "Save your recovery codes",
    mfa_recovery_description: "These one-time codes are shown only now. Store them somewhere secure.",
    mfa_recovery_acknowledge: "I saved these recovery codes in a secure place.",
    mfa_recovery_missing: "Recovery codes were not returned. Contact an administrator before continuing.",
    copy_codes: "Copy codes",
    copied: "Copied",
    continue: "Continue",
    invite_title: "Accept your invitation",
    invite_description: "Create a strong password, then secure your account with an authenticator.",
    invite_password_length: "Password must contain at least 12 characters.",
    invite_password_policy: "Use at least 12 characters with uppercase, lowercase, number, and symbol.",
    invite_password_hint: "Use at least 12 characters with uppercase, lowercase, number, and symbol. Do not reuse another password.",
    invite_accept: "Accept invitation",
    invite_enrollment_required: "Authenticator enrollment is required to activate this invitation.",
    new_password: "New password",
    confirm_password: "Confirm password",
    passwords_do_not_match: "Passwords do not match.",
    required_capability: "Required capability",
    workspace_switcher: "Active customer workspace",
    workspace_platform: "Platform",
    workspace_switch_failed: "Unable to switch workspace",
    invite_user: "Invite user",
    invite_only_hint: "The user sets their own password from a secure email invitation.",
    send_invitation: "Send invitation",
    invitation_sent: "Invitation sent",
    invitation_email_failed: "The user was created, but the invitation email could not be sent. Configure the Fleet mail server and resend it.",
    customer_workspaces: "Customer workspaces",
    platform_access: "Platform access",
    platform_required_hint: "Fleet Portal remains enabled for secure onboarding and account management.",
    custom_capabilities: "Custom capabilities",
    reset_role_defaults: "Reset to role defaults",
    workspace_required: "Select at least one customer workspace.",
    no_workspaces: "No customer workspaces are available.",
    user_required_fields: "Username, full name, and a valid email are required.",
    capabilities_load_failed: "Capabilities could not be loaded.",
    users_load_failed: "Users could not be loaded.",
    user_save_failed: "User could not be saved.",
    deactivate_user_confirm: "Deactivate {{username}}?",

    // Auth / Protected Route
    checking_auth: "Checking authentication...",
    access_denied: "Access Denied",
    access_denied_message: "You don't have permission to access this page.",
    required_role: "Required role",
    your_role: "Your role",
    go_back: "Go Back",
    logout: "Logout",

    // Vehicle Status
    // Blue while driving, green while parked, red once the signal is gone,
    // grey when no tracker is fitted.
    tracking_moving: "Moving",
    tracking_parked: "Parked",
    tracking_no_signal: "No signal",
    tracking_offline: "Offline",
    tracking_not_tracked: "Not tracked",
    vehicle_pucks: "Vehicle pucks",
    moving: "Moving",
    stopped: "Stopped",
    idle: "Idle",
    offline: "Offline",
    maintenance: "Maintenance",
    en_route: "En Route",
    out_of_service: "Out of Service",

    // Vehicle List
    vehicle_list: "Vehicle List",
    no_vehicles: "No vehicles available",
    search_vehicles: "Search vehicles...",
    no_vehicles_found: "No vehicles found",
    try_adjusting_search: "Try adjusting your search",
    selected_vehicle: "Selected Vehicle",
    booking: "Booking",
    battery: "Battery",
    signal: "Signal",

    // Driver assignment (Driver tab of the vehicle window)
    current_driver: "Current driver",
    assign_driver: "Assign a driver",
    choose_driver: "Choose a driver",
    search_driver: "Search a driver…",
    release_driver: "Release driver",
    no_current_driver: "No driver is assigned to this vehicle.",
    no_drivers_hint: "No active driver exists yet. Add one in Fleet Staff Management.",
    driver_handover_hint: "Assigning another driver ends the current assignment at the same moment.",
    driver_history: "Driver history",
    no_driver_history: "No driver has ever been assigned to this vehicle.",
    driver_assigned: "Driver assigned",
    driver_assign_failed: "Failed to assign the driver",
    driver_released: "Driver released",
    driver_release_failed: "Failed to release the driver",
    since: "Since",
    no_match: "No match",

    // Vehicle Info
    select_vehicle: "Select a vehicle",
    to_see_info: "to see its information",
    current_status: "Current Status",
    driver: "Driver",
    location: "Location",
    address_not_available: "Address not available",
    metrics: "Metrics",
    heading: "Heading",
    device_status: "Device Status",
    fuel: "Fuel",
    temperature: "Temperature",
    additional_info: "Additional Information",
    odometer: "Odometer",
    engine_hours: "Engine Hours",
    view_full_history: "View Full History",
    generate_report: "Generate Report",

    // Timeline
    timeline: "Timeline",
    select_vehicle_timeline: "Select a vehicle to see its timeline",
    last_hour: "Last hour",
    last_6_hours: "Last 6 hours",
    last_12_hours: "Last 12 hours",
    last_24_hours: "Last 24 hours",
    last_3_days: "Last 3 days",
    no_timeline_data: "No timeline data available",
    current_speed: "Current speed",

    // Map
    vehicle_status_legend: "Vehicle Status",
    fleet_map: "Fleet Map",

    // Dashboard
    dashboard_title: "SiniFleet",
    window_layout_management: "Window Layout Management",
    window_layouts: "Window Layouts",
    office_layout: "Office",
    office_layout_desc: "Map + Vehicles + Speed + Events + Corridors",
    focus_mode: "Focus",
    focus_mode_desc: "Map + Corridors only",
    monitoring: "Monitoring",
    monitoring_desc: "Map + Speed + Events analytics",
    minimal: "Minimal",
    minimal_desc: "Map only, clean workspace",
    mission_ops: "Mission Operations",
    mission_ops_desc: "Map + Missions + Staff + Vehicles",
    fleet_admin: "Fleet Administration",
    fleet_admin_desc: "Users + Vehicles + Alerts management",
    full_operations: "Full Operations",
    full_operations_desc: "All windows open for complete oversight",
    panels_active: "panels active",
    custom_layouts: "Custom Layouts",
    save_current_layout: "Save Current Layout",
    save_layout: "Save Layout",
    reset_to_default: "Reset to Default",
    enter_layout_name: "Enter layout name (e.g., My Workspace)",
    delete_layout: "Delete layout",
    layout_saved: "Layout saved successfully",
    layout_deleted: "Layout deleted",
    layout_reset: "Reset to default layout",
    switch_light_mode: "Switch to Light Mode",
    switch_dark_mode: "Switch to Dark Mode",
    layout_mode: "Window Mode",
    layout_floating: "Floating",
    layout_fixed: "Fixed Grid",
    layout_dashboard: "Dashboard",
    preset_layouts: "Preset Layouts",
    layout_applied: "Layout \"{{name}}\" applied",
    workspace_mode: "Workspace mode",
    workspace_fixed: "Fixed workspace",
    workspace_fixed_desc: "Use one module at a time with persistent navigation.",
    workspace_mac: "Mac windows",
    workspace_mac_desc: "Open, move, resize and minimize multiple windows.",
    workspace_navigation: "Workspace modules",
    workspace_group_tracking: "Tracking",
    workspace_group_operations: "Operations",
    workspace_group_administration: "Administration",
    workspace_group_management: "Management",

    // Transport assignment (itinerary / departure-destination)
    transport_assign_title: "Assign transport",
    transport_mode_itinerary: "Itinerary",
    transport_mode_places: "Departure / destination",
    transport_itinerary: "Itinerary (trajectory)",
    transport_select_itinerary: "Select a trajectory…",
    transport_no_itineraries: "No trajectories defined yet — create one in Trajectories.",
    transport_itinerary_hint: "Departure and destination are taken from the trajectory endpoints; progress follows the route.",
    transport_departure: "Departure",
    transport_destination: "Destination",
    transport_select_place: "Select a place…",
    transport_no_itinerary_option: "No itinerary — pick departure and destination below",
    base_location: "Base location (manual note)",
    base_location_hint: "Free note (depot, yard…). Live GPS position comes from the balise; departure is the transport start point.",
    transport_no_places: "No places yet — places come from trajectory endpoints and geofences.",
    transport_pick_places: "Pick a departure and a destination",
    transport_save: "Assign",
    transport_clear: "Clear transport",
    transport_save_failed: "Failed to save transport",
    transport_progress: "Route progress",
    workspace_collapse_panel: "Collapse vehicle panel",
    workspace_expand_panel: "Expand vehicle panel",
    workspace_show_vehicles: "Vehicles",
    workspace_dock_collapse: "Collapse analytics",
    workspace_dock_expand: "Expand analytics",
    workspace_drawer_resize: "Drag to resize panel",
    period_label: "Period",
    data_points: "Data points",
    avg_short: "avg",
    speed_select_hint: "to view its speed chart",
    speed_no_data: "No speed data",
    speed_actual: "Actual speed",
    for_selected_period: "for the selected period",
    events_select_hint: "Select a vehicle to view stop events and balise activities",
    stop_events_title: "Stops > 10 min",
    balise_events_title: "Balise events",
    no_stop_events: "No stop events longer than 10 minutes found",
    no_balise_events: "No balise events found for the selected period",
    recent_events: "Recent events:",
    long_stops: "Long stops",
    total_stop_time: "Total stop time",
    detailed_stops: "Detailed stop events",
    access_lock_events: "Access/Lock events",
    duration_min: "Duration (min)",
    stop_duration: "Stop duration",

    // Dashboard Windows
    speed_analysis: "Speed Analysis",
    event_analysis: "Event Analysis",
    corridor_management: "Corridor Management",
    corridor_mgmt_desc: "Map + Vehicles + Corridors",
    user_management_title: "User Management",
    alert_rules_system: "Alert and Rules System",
    fleet_assignment_config: "Fleet Assignment & Alerts",
    fleet_assignment_config_desc: "Configure alerts, geofences, and corridor assignments for containers and assets",
    fleet_staff_management: "Fleet Staff Management",
    fleet_vehicle_operations: "Fleet Vehicle Operations",
    mission_control_system: "Mission Control System",
    fleet_vehicles: "Fleet Vehicles",
    corridors_geofences: "Corridors & Geofences",
    user_role_management: "User & Role Management",
    events_analysis: "Events Analysis",

    // Taskbar
    auto_hide_on: "Auto-Hide ON - Taskbar will hide automatically",
    auto_hide_off: "Auto-Hide OFF - Taskbar stays visible",
    disable_corridor_tracking: "Disable Corridor Tracking",
    enable_corridor_tracking: "Enable Corridor Tracking",
    hide_corridor: "Hide corridor",
    show_corridor: "Show corridor",
    tracking_active: "Tracking Active",
    center_on_corridors: "Center on corridors",
    more_corridors: "+{{count}} more corridors",
    na: "N/A",

    // Mission Dashboard
    mission_dashboard: "Mission Dashboard",
    new_mission: "New Mission",
    search_missions: "Search missions...",
    active_missions: "Active",
    completed_missions: "Completed",
    delayed_missions: "Delayed",
    edit_mission: "Edit Mission",
    delete_mission: "Delete Mission",
    unassigned: "Unassigned",
    manage_tasks: "Manage Tasks",
    start: "Start",
    mission_progress: "Mission Progress",
    mission_details: "Mission Details",
    planned_start: "Planned Start",
    planned_end: "Planned End",
    actual_start: "Actual Start",
    select_mission: "Select a Mission",
    select_mission_desc: "Choose a mission from the list to view details and progress",
    loading_missions: "Loading mission control...",
    mission_created: "Mission \"{{name}}\" created successfully",
    mission_updated: "Mission \"{{name}}\" updated successfully",
    mission_deleted: "Mission \"{{name}}\" deleted successfully!",
    delete_mission_confirm: "Are you sure you want to delete the mission \"{{name}}\"?",
    delete_mission_warning: "This will permanently delete:",
    delete_mission_items: "Mission details and progress, All associated tasks, Mission history and logs",
    no_missions: "No missions found",
    failed_load_missions: "Failed to load missions from server",
    failed_delete_mission: "Failed to delete mission",
    alert_sequence_progress: "Alert Sequence Progress",
    departure: "Departure",
    arrival: "Arrival",
    return_trip: "Return",
    loading_status: "Loading",
    in_progress: "In Progress",
    planned: "Planned",
    customer: "Customer",

    // Mission Creator
    create_new_mission: "Create New Mission",
    edit_mission_title: "Edit Mission",
    mission_setup_progress: "Mission Setup Progress",
    mission_editing: "Mission Editing",
    update_mission_details: "Update mission details",
    step_of: "Step {{current}} of {{total}}",
    mission_information: "Mission Information",
    mission_name: "Mission Name",
    mission_name_placeholder: "e.g., Delivery to Port of Bamako",
    mission_type: "Mission Type",
    mission_description: "Mission details...",
    staff_assignment: "Staff Assignment",
    assign_staff: "Assign Staff Members",
    primary_staff: "Primary Responsible Staff",
    select_primary_staff: "Select primary staff...",
    additional_staff: "Additional Staff (Optional)",
    primary_label: "PRIMARY",
    total_staff_assigned: "Total staff assigned",
    loading_staff: "Loading available staff...",
    no_staff_available: "No staff available for this mission type",
    vehicle_assignment: "Vehicle Assignment",
    filter_by_customer: "Filter by Customer",
    filter_by_type: "Filter by Type",
    all_customers: "All Customers",
    all_types: "All Types",
    search_vehicles_ellipsis: "Search vehicles...",
    select_vehicles: "Select Vehicles (Optional)",
    vehicles_match: "{{count}} vehicles match filters",
    asset: "Asset",
    plate: "Plate",
    owner: "Owner",
    container: "Container",
    vehicles_selected: "{{count}} vehicles selected",
    loading_vehicles: "Loading available vehicles...",
    no_vehicles_available: "No vehicles available",
    alert_route_config: "Alert & Route Configuration",
    create_alert: "Create Alert",
    select_mission_alerts: "Select Mission Alerts (Optional)",
    select_alerts_desc: "Choose alerts that will monitor this mission",
    manual_route: "Manual Route Information (Optional)",
    origin_address: "Origin address...",
    destination_address: "Destination address...",
    schedule: "Schedule",
    planned_start_time: "Planned Start Time",
    planned_end_time: "Planned End Time",
    customer_information: "Customer Information",
    select_customer: "Select Customer",
    customer_name_manual: "Customer Name (Manual Entry)",
    creating: "Creating...",
    updating: "Updating...",
    create_mission: "Create Mission",
    update_mission: "Update Mission",
    please_fill_mission: "Please fill in mission name and assign primary staff",
    failed_load_staff: "Failed to load staff data",
    failed_load_vehicles: "Failed to load vehicle data",
    failed_load_form: "Failed to load form data",
    failed_create_mission: "Failed to create mission",
    please_login: "Please login first to create missions",

    // Mission types
    transport_operations: "Transport Operations",
    logistics_operations: "Logistics Operations",
    maintenance_operations: "Maintenance Operations",
    security_operations: "Security Operations",
    provider_operations: "Provider Operations",
    administrative_operations: "Administrative Operations",
    delivery: "Delivery",
    pickup: "Pickup",
    round_trip: "Round Trip",
    priority_low: "Low",
    priority_medium: "Medium",
    priority_high: "High",
    priority_urgent: "Urgent",

    // User Management
    user_management: "User Management",
    manage_users_desc: "Manage system users and permissions",
    add_user: "Add User",
    search_users: "Search users by name, email, username, department...",
    role: "Role",
    all_roles: "All Roles",
    administrator: "Administrator",
    operator: "Operator",
    viewer: "Viewer",
    fleet_manager: "Fleet Manager",
    all_users: "All Users",
    active_only: "Active Only",
    inactive_only: "Inactive Only",
    users_count: "{{shown}} of {{total}} users",
    admins: "Admins",
    operators: "Operators",
    viewers: "Viewers",
    loading_users: "Loading users...",
    no_users_found: "No users found",
    try_adjusting_filters: "Try adjusting your search or filters",
    last_login: "Last login",
    edit_user: "Edit user",
    delete_user: "Delete user",
    create_new_user: "Create New User",
    full_name: "Full Name",
    email: "Email",
    phone: "Phone",
    department: "Department",
    active_user: "Active User",
    permissions: "Permissions",
    user_notes: "Additional notes about this user...",
    user_created: "User \"{{name}}\" created successfully",
    user_updated: "User \"{{name}}\" updated successfully",
    user_deactivated: "User \"{{name}}\" deactivated successfully",
    delete_user_confirm: "Delete user \"{{name}}\"? This action cannot be undone.",
    failed_load_users: "Failed to load users",
    failed_create_user: "Failed to create user",
    failed_update_user: "Failed to update user",
    failed_delete_user: "Failed to delete user",

    // Role descriptions
    viewer_desc: "Read-only access",
    operator_desc: "Daily operations",
    fleet_manager_desc: "Full operations",
    admin_desc: "Full system access",
    customer_role_desc: "Own vehicles only",

    // Staff Management
    staff_management: "Fleet Staff Management",
    staff_management_desc: "Manage drivers, supervisors, and operational staff",
    drivers: "Drivers",
    supervisors: "Supervisors",
    prestateurs: "Prestateurs",
    add_staff: "Add Staff Member",
    staff_directory: "Staff Directory",
    availability: "Availability",
    performance: "Performance",
    certifications: "Certifications",
    search_staff: "Search staff...",
    all_staff_types: "All Types",
    staff_drivers: "Drivers",
    staff_supervisors: "Supervisors",
    staff_loaders: "Loaders",
    staff_coordinators: "Coordinators",
    staff_maintenance: "Maintenance",
    staff_security: "Security",
    staff_external: "External Providers",
    all_status: "All Status",
    on_leave: "On Leave",
    staff_code: "Staff Code",
    license: "License",
    missions_count: "Missions",
    company: "Company",
    external: "External",
    internal: "Internal",
    personal_info: "Personal Information",
    hire_date: "Hire Date",
    professional_info: "Professional Information",
    shift_pattern: "Shift Pattern",
    supervisor: "Supervisor",
    driver_info: "Driver Information",
    license_number: "License Number",
    license_class: "License Class",
    license_expiry: "License Expiry",
    expiring_soon: "Expiring Soon",
    missions_completed: "Missions Completed",
    employment_summary: "Employment Summary",
    employment_type: "Employment Type",
    external_provider: "External Provider",
    internal_staff: "Internal Staff",
    provider_company: "Provider Company",
    provider_type: "Provider Type",
    freight_forwarder: "Freight Forwarder",
    customs_broker: "Customs Broker",
    contract_carrier: "Contract Carrier",
    seniority: "Seniority",
    performance_metrics: "Performance Metrics",
    performance_desc: "Detailed performance analytics will be implemented here.",
    certifications_desc: "Certification management will be implemented here.",
    select_staff: "Select a Staff Member",
    select_staff_desc: "Choose a staff member from the list to view details",
    remove_staff_confirm: "Are you sure you want to remove {{name}} from the system?",
    staff_removed: "Staff member {{name}} removed successfully",

    // Alert Management
    alert_management: "Fleet Alert Management",
    alert_management_desc: "Create, manage and configure fleet alerts",
    alert_guide: "Alert Guide",
    manage_alerts: "Manage Alerts",
    new_alert: "New Alert",
    alerts_count: "{{count}} Alerts",
    vehicles_count: "{{count}} Vehicles",
    zones_count: "{{count}} Zones",
    routes_count: "{{count}} Routes",
    alert_updated: "Alert \"{{name}}\" updated successfully!",
    alert_created: "Alert \"{{name}}\" created successfully!",
    alert_activated: "Alert \"{{name}}\" activated",
    alert_deactivated: "Alert \"{{name}}\" deactivated",
    alert_deleted: "Alert \"{{name}}\" deleted successfully",
    delete_alert_confirm: "Are you sure you want to delete the alert \"{{name}}\"?",
    failed_load_geofences: "Failed to load geofences for alerts",
    failed_load_corridors: "Failed to load corridors for alerts",

    // Alert Creation
    alert_creation_wizard: "Alert Creation Wizard",
    step_n_of_m: "Step {{n}} of {{m}}",
    percent_complete: "% Complete",
    alert_name: "Alert Name",
    alert_name_desc: "Enter a descriptive name for your alert",
    alert_name_placeholder: "e.g., Warehouse Entry Alert, Speed Limit Warning...",
    alert_type_config: "Alert Type & Configuration",
    alert_type_config_desc: "Choose alert type and configure its parameters",
    alert_type: "Type of Alert",
    choose_alert_type: "Choose alert type...",
    alert_config: "Alert Configuration",
    description_optional: "Description (Optional)",
    priority_level: "Priority Level",
    time_settings: "Time Settings",
    start_time: "Start Time",
    end_time: "End Time",
    active_days: "Active Days",
    authorization_level: "Authorization Level",
    speed_settings: "Speed Settings",
    speed_limit: "Speed Limit (km/h)",
    tolerance: "Tolerance (km/h)",
    dwell_time_settings: "Dwell Time Settings",
    max_dwell_time: "Maximum Dwell Time (minutes)",
    custom_alert_message: "Custom Alert Message (Optional)",
    dwell_threshold: "Dwell Time Threshold (minutes)",
    timeout_duration: "Timeout Duration (minutes)",
    enable_email_notifications: "Enable Email Notifications",
    select_locations: "Select Locations",
    select_locations_desc: "Choose geofences and/or routes for this alert",
    select_geofences: "Select Geofences",
    geofences_selected: "{{count}} selected",
    click_to_choose_areas: "Click to choose areas",
    select_routes: "Select Routes",
    routes_selected: "{{count}} selected",
    click_to_choose_routes: "Click to choose routes",
    selected_locations: "Selected Locations",
    geofences: "Geofences",
    routes: "Routes",
    remove_geofence: "Remove geofence",
    remove_route: "Remove route",
    select_vehicles_alert: "Select Vehicles",
    select_vehicles_alert_desc: "Choose which vehicles this alert applies to",
    vehicle_groups: "Vehicle Groups",
    all_fleet: "All Fleet",
    trucks_only: "Trucks Only",
    container_vehicles: "Container Vehicles",
    light_vehicles: "Light Vehicles",
    individual_vehicles: "Individual Vehicles",
    active_alert: "Active Alert",
    alert_enabled_immediately: "Alert will be enabled immediately",
    update_alert: "Update Alert",
    loading_map_data: "Loading map data...",

    // Alert types
    location_alerts: "Location Alerts",
    safety_alerts: "Safety Alerts",
    route_alerts: "Route Alerts",
    technical_alerts: "Technical Alerts",
    logistics_alerts: "Logistics Alerts",
    mission_alerts: "Mission Alerts",
    geofence_entry: "Geofence Entry",
    speed_violation: "Speed Violation",
    route_deviation: "Route Deviation",
    loading_timeout: "Loading Timeout",
    mission_timeout: "Mission Timeout",

    // Geofence/Corridor
    geofence_selection: "Geofence Selection",
    search_geofences: "Search geofences...",
    all_geofences: "All Types",
    circles: "Circles",
    squares: "Squares",
    polygons: "Polygons",
    route_selection: "Route Selection",
    search_routes: "Search routes...",
    all_routes: "All Routes",
    short_routes: "Short Routes (<50km)",
    long_routes: "Long Routes (>50km)",
    waypoints: "Waypoints",
    corridor: "Corridor",
    geofence: "Geofence",
    address: "Address",
    city: "City",
    radius: "Radius",
    area: "Area",
    loading_location: "Loading location...",
    loading_route_info: "Loading route info...",

    // Corridor Manager
    corridor_management_title: "Corridor Management",
    trajectories: "Trajectories",
    draw_route: "Draw Route",
    add_geofence: "Add Geofence",
    create_new_corridor: "Create New Corridor",
    edit_corridor: "Edit Corridor",
    corridor_name: "Corridor Name",
    corridor_name_placeholder: "Enter corridor name...",
    description_placeholder: "Enter description...",
    color: "Color",
    width: "Width",
    active_corridor: "Active Corridor",
    no_trajectories: "No trajectories found",
    no_trajectories_desc: "Click \"Draw Route\" to create your first trajectory",
    no_geofences: "No geofences found",
    no_geofences_desc: "Use the drawing tools to create geofences",
    editing: "Editing",
    entry: "Entry",
    exit: "Exit",
    route_updated: "Route updated successfully!",
    route_deleted: "Route deleted successfully!",
    geofence_updated: "Geofence updated successfully!",
    geofence_deleted: "Geofence deleted successfully!",
    delete_corridor_confirm: "Are you sure you want to delete this corridor?",
    delete_geofence_confirm: "Are you sure you want to delete this geofence?",
    error_updating_route: "Error updating route",
    error_deleting_route: "Error deleting route",
    error_updating_geofence: "Error updating geofence",
    error_deleting_geofence: "Error deleting geofence",

    // Vehicle Operations
    vehicle_management: "Vehicle Management",
    vehicle_management_desc: "Complete fleet management: real-time vehicle tracking",
    new_vehicle: "New Vehicle",
    total_vehicles: "Total Vehicles",
    active_vehicles: "Active",
    in_maintenance: "In Maintenance",
    alerts: "Alerts",
    average_age: "Average Age",
    overview: "Overview",
    fuel_tab: "Fuel",
    analytics: "Analytics",
    vehicle_attributes: "Vehicle Attributes",
    search_vehicles_detail: "Search by code, plate, make, model or customer...",
    all_statuses: "All Statuses",
    all_vehicle_types: "All Types",
    trucks: "Trucks",
    vans: "Vans",
    pickups: "Pickups",
    containers: "Containers",
    vehicle: "Vehicle",
    balises: "Balises",
    specifications: "Specifications",
    not_assigned: "Not assigned",
    no_customer_code: "No customer code",
    no_balise: "No balise",
    no_tracking: "No tracking",
    consumption_na: "Consumption N/A",
    insurance_expiring: "Insurance Expiring Soon",
    service_overdue: "Service Overdue",
    service_due_soon: "Service Due Soon",
    ok: "OK",
    view_details: "View Details",
    edit_vehicle: "Edit Vehicle",
    delete_vehicle: "Delete Vehicle",
    delete_vehicle_confirm: "Are you sure you want to delete vehicle {{code}}?",
    vehicle_deleted: "Vehicle {{code}} deleted successfully",
    error_deleting_vehicle: "Error deleting vehicle",
    loading_vehicles_db: "Loading vehicles...",
    integrating_data: "Integrating assets, containers, and balise data",
    maintenance_management: "Maintenance Management",
    schedule_maintenance: "Schedule Maintenance",
    maintenance_history: "Maintenance History",
    no_maintenance: "No maintenance found",
    no_maintenance_records: "No maintenance records found for the selected period",
    fuel_management: "Fuel Management",
    record_fuel_fill: "Record Fuel Fill",
    fuel_history: "Fuel Fill History",
    no_fuel_fills: "No fuel fills found",
    no_fuel_records: "No fuel fills recorded for the selected period",
    analytics_reports: "Analytics & Reports",
    fleet_performance: "Fleet Performance",
    average_utilization: "Average Utilization",
    filter_by_period: "Filter by Period",

    // Task Manager
    task_management: "Task Management",
    resources: "Resources",
    list_view: "List",
    gantt_view: "Gantt",
    calendar_view: "Calendar",
    add_task: "Add Task",
    gantt_chart: "Gantt Chart View",
    task: "Task",
    no_tasks: "No Tasks Created",
    no_tasks_desc: "Create your own tasks for this mission",
    create_first_task: "Create First Task",
    no_location: "No location",
    progress: "Progress",
    start_task: "Start Task",
    complete_task: "Complete Task",
    edit_task: "Edit Task",
    delete_task: "Delete Task",
    create_new_task: "Create New Task",
    task_name: "Task Name",
    task_name_placeholder: "e.g. Load containers...",
    assign_staff_from_mission: "From mission assigned staff",
    assign_vehicles_from_mission: "From mission assigned vehicles",
    assign_alerts_from_mission: "From mission assigned alerts",
    start_date: "Start Date",
    end_date: "End Date",
    duration_hours: "Duration (hours)",
    task_location: "Task location...",
    task_notes: "Task instructions or notes...",
    update_task: "Update Task",
    create_task: "Create Task",
    task_created: "Task \"{{name}}\" created",
    task_updated: "Task status updated",
    task_deleted: "Task deleted",
    please_fill_task: "Please fill in task name and assign staff",
    no_staff_in_mission: "No staff assigned to this mission",
    no_vehicles_in_mission: "No vehicles assigned to this mission",
    no_alerts_in_mission: "No alerts assigned to this mission",

    // Role Management
    role_management: "Role Management",

    // Days of week
    sun: "Sun",
    mon: "Mon",
    tue: "Tue",
    wed: "Wed",
    thu: "Thu",
    fri: "Fri",
    sat: "Sat",

    // Priority levels
    low: "Low",
    medium: "Medium",
    high: "High",
    urgent: "Urgent",
    critical: "Critical",
    public_level: "Public",
    restricted: "Restricted",
    private_level: "Private",
    emergency: "Emergency",

    // Language
    language: "Language",
    english: "English",
    french: "Français",

    // Panel labels for CompleteFleetDashboard
    balise_management: "Balise Management",
    customer_management: "Customer Management",
    container_management: "Container Management",
    asset_management: "Asset Management",
    settings_management: "Settings",
    bm_dashboard: "Balise Dashboard",
    balise_operations: "Balise Operations",
    balise_operations_desc: "Balises, customers, containers, assets, settings",

    // Balise management
    balise_mgmt_title: "Balise management",
    balise_mgmt_subtitle: "GPS trackers for vehicles and containers",
    balise_tab_inventory: "Balises-IOTs",
    balise_tab_commands: "Commands",
    balise_tab_sync: "Sync control",
    balise_tab_decommission: "Decommission",
    balise_tab_jointech_maxvision: "Jointech / MaxVision",
    balise_tab_jimi: "JIMI",
    balise_jimi_no_onboarded: "No JIMI balise onboarded yet. Use the catalog below to add one.",
    balise_jimi_command_unavailable_tooltip: "Lock / unlock for JIMI devices is not enabled yet (coming with command routing).",
    balise_jimi_onboarded_title: "Onboarded JIMI balises",
    balise_jimi_onboarded_subtitle: "JIMI devices already registered in the fleet portal.",
    balise_jimi_catalog_title: "Available JIMI captors",
    balise_jimi_catalog_subtitle: "Devices visible on the TurboHive vendor side but not yet onboarded here.",
    balise_jimi_catalog_checked_at: "last checked",
    balise_jimi_catalog_unreachable: "TurboHive vendor catalog is currently unreachable. The JIMI side may simply have no devices online yet — try again later.",
    balise_jimi_catalog_empty: "No JIMI captor reported by TurboHive yet. Once a JIMI device connects to the platform it will appear here, ready to be onboarded.",
    balise_jimi_captors_upstream_error: "TurboHive catalog is unreachable",
    balise_jimi_captors_load_failed: "Failed to load JIMI captors",
    balise_jimi_col_imei: "IMEI / ID",
    balise_jimi_col_name: "Name",
    balise_jimi_col_model: "Model",
    balise_jimi_col_status: "Vendor status",
    balise_jimi_col_last_seen: "Last seen",
    balise_jimi_onboard_action: "Onboard",
    balise_jimi_onboard_tooltip: "Onboard this JIMI captor as a balise (preview)",
    balise_jimi_onboard_coming_soon: "Onboarding JIMI captors will be enabled with the next release.",
    system_monitoring_title: "System monitoring",
    system_monitoring_subtitle: "Platform-side health for vendor integrations and ingest pipelines",
    system_monitoring_jimi_section: "JIMI ingest pipeline",
    system_monitoring_admin_only_title: "Administrator access required",
    system_monitoring_admin_only_msg: "This panel exposes platform-side health metrics. Ask an administrator if you need access.",
    admin_shortcut_tooltip: "Open system monitoring",
    // P10 — universal balise inventory: brand-agnostic device-type chips
    bm_filter_type_all: "All types",
    bm_filter_type_lock: "Smart Lock",
    bm_filter_type_gps: "GPS Tracker",
    bm_filter_type_dashcam: "Dashcam",
    bm_filter_type_obd: "OBD",
    bm_filter_type_tag: "BLE Tag",
    bm_filter_brand_all: "All brands",
    // (P10 adaptive panel keys removed; row-action handlers fire
    // device-specific commands directly. Smart-lock / dashcam / OBD /
    // tag helpers now live on dedicated asset windows.)
    // Asset attach flow (kept after JimiConsole removal — reused by the
    // unified balise modal). The "jimi_" prefix is historical only; these
    // strings drive the AttachAssetModal regardless of brand.
    jimi_attach_title: "Attach to asset",
    jimi_attach_subtitle: "Pick the asset {{device}} should be attached to",
    jimi_attach_search_placeholder: "Search by code, plate, brand, model, customer…",
    jimi_attach_count: "{{n}} assets",
    jimi_attach_loading: "Loading assets…",
    jimi_attach_empty: "No assets match your search.",
    jimi_attach_current: "CURRENT",
    jimi_attach_already_attached: "This balise is currently attached to {{asset}}. Confirming will move it to the new asset.",
    jimi_attach_confirm: "Attach",
    jimi_attach_success: "Balise attached to {{asset}}",
    jimi_detach_success: "Balise detached from asset",
    jimi_card_attach: "Attach to asset",
    jimi_card_detach: "Detach from asset",
    jimi_detach_failed: "Detach failed",
    // P8 / P10 — asset-centric peripheral picker (renamed from jimi_picker_*)
    peripheral_picker_title: "Open peripheral tracking",
    peripheral_picker_subtitle: "This asset has multiple peripherals attached. Click a card to open one, or tick checkboxes to open several.",
    peripheral_picker_close: "Close",
    peripheral_picker_empty: "No peripherals attached to this asset.",
    peripheral_picker_online: "Online",
    peripheral_picker_offline: "Offline",
    peripheral_picker_last_seen: "Last seen",
    peripheral_picker_no_imei: "IMEI missing — cannot open peripheral window.",
    peripheral_picker_select_aria: "Select peripheral",
    peripheral_picker_count_selected: "{{count}} selected",
    peripheral_picker_clear: "Clear",
    peripheral_picker_open_btn: "Open",
    asset_window_no_binding: "Select an asset on the map or vehicle list to populate this window.",
    // Smart-lock asset window
    asset_lock_default_name: "Smart Lock",
    asset_lock_btn_seal: "Seal",
    asset_lock_btn_unseal: "Unseal",
    asset_lock_btn_wakeup: "Wakeup",
    asset_lock_no_write: "Operator role required",
    asset_lock_tab_events: "Lock events",
    asset_lock_tab_history: "Command history",
    asset_lock_tab_offline: "Offline queue",
    asset_lock_refresh: "Refresh",
    asset_lock_events_empty: "No lock events for this asset yet.",
    asset_lock_history_empty: "No commands sent yet.",
    asset_lock_offline_empty: "No queued offline commands.",
    asset_lock_cancel: "Cancel",
    asset_lock_col_time: "Time",
    asset_lock_col_event: "Event",
    asset_lock_col_severity: "Severity",
    asset_lock_col_lock: "Lock",
    asset_lock_col_cmdNo: "cmdNo",
    asset_lock_col_status: "Status",
    asset_lock_col_ack: "Ack",
    asset_lock_command_ok: "{{action}} command sent",
    asset_lock_command_warn: "{{action}}: {{msg}}",
    asset_lock_command_error: "{{action}} failed: {{msg}}",
    asset_lock_offline_cancel_ok: "Offline command cancelled",
    asset_lock_offline_cancel_error: "Cancel failed: {{msg}}",
    asset_lock_events_load_error: "Failed to load lock events: {{msg}}",
    asset_lock_history_load_error: "Failed to load command history: {{msg}}",
    asset_lock_offline_load_error: "Failed to load offline queue: {{msg}}",
    // Dashcam asset window
    asset_dashcam_default_name: "AI Dashcam",
    asset_dashcam_read_only: "View only — operator role required for video controls.",
    asset_dashcam_tab_live: "Live",
    asset_dashcam_tab_snapshot: "Snapshot",
    asset_dashcam_tab_recorded: "Recorded",
    asset_dashcam_start_live: "Start live",
    asset_dashcam_stop_live: "Stop live",
    asset_dashcam_capture: "Capture",
    asset_dashcam_capture_now: "Capture now",
    asset_dashcam_live_idle: "Live stream not started.",
    asset_dashcam_snapshot_empty: "No snapshot captured yet.",
    asset_dashcam_files_empty: "No clips found.",
    asset_dashcam_search: "Search",
    asset_dashcam_play: "Play",
    asset_dashcam_stop: "Stop",
    asset_dashcam_from: "From",
    asset_dashcam_to: "To",
    asset_dashcam_live_started: "Live stream started",
    asset_dashcam_live_stopped: "Live stream stopped",
    asset_dashcam_live_start_error: "Failed to start live: {{msg}}",
    asset_dashcam_live_stop_error: "Failed to stop live: {{msg}}",
    asset_dashcam_snapshot_ok: "Snapshot requested",
    asset_dashcam_snapshot_error: "Snapshot failed: {{msg}}",
    asset_dashcam_files_load_error: "Failed to list clips: {{msg}}",
    asset_dashcam_playback_error: "Playback failed: {{msg}}",
    // OBD asset window
    asset_obd_default_name: "OBD Telemetry",
    asset_obd_refresh: "Refresh",
    asset_obd_live_section: "Live snapshot",
    asset_obd_history_section: "History",
    asset_obd_no_data: "No Data",
    asset_obd_from: "From",
    asset_obd_to: "To",
    asset_obd_apply: "Apply",
    asset_obd_history_empty: "No OBD history rows in this range.",
    asset_obd_col_time: "Time",
    asset_obd_prev: "Previous",
    asset_obd_next: "Next",
    asset_obd_page: "Page {{page}}",
    asset_obd_latest_error: "Failed to load latest OBD: {{msg}}",
    asset_obd_history_error: "Failed to load OBD history: {{msg}}",
    asset_obd_acc: "ACC",
    asset_obd_speed: "Speed",
    asset_obd_engine_speed: "Engine Speed",
    asset_obd_fuel_level: "Fuel Level",
    asset_obd_battery_voltage: "Battery Voltage",
    asset_obd_coolant_temp: "Coolant Temperature",
    asset_obd_intake_air_temp: "Intake Air Temperature",
    asset_obd_throttle_pos: "Throttle Position",
    asset_obd_throttle_abs_pos: "Throttle Absolute Position",
    asset_obd_manifold_pressure: "Manifold Pressure",
    asset_obd_mass_air_flow: "Mass Air Flow",
    asset_obd_instant_fuel: "Instant Fuel Consumption",
    asset_obd_avg_fuel: "Average Fuel Consumption",
    asset_obd_total_fuel: "Total Fuel Consumption",
    asset_obd_engine_runtime: "Engine Runtime",
    asset_obd_odometer: "Odometer",
    asset_obd_cum_mileage: "Cumulative Mileage",
    asset_obd_vehicle_type: "Vehicle Type",
    // Tags asset window
    asset_tags_default_name: "Paired Tags",
    asset_tags_refresh: "Refresh",
    asset_tags_empty: "No paired tags reported by this device.",
    asset_tags_history_empty: "No history rows.",
    asset_tags_col_time: "Time",
    asset_tags_col_value: "Value",
    asset_tags_col_rssi: "RSSI",
    asset_tags_col_battery: "Battery",
    asset_tags_load_error: "Failed to load tags: {{msg}}",
    asset_tags_history_error: "Failed to load tag history: {{msg}}",
    balise_stat_total: "Total",
    balise_stat_active: "Active",
    balise_stat_low_battery: "Low battery",
    balise_stat_offline: "Offline",
    balise_search_placeholder: "Search by lock code, device, customer...",
    balise_filter_assignment: "Assignment status",
    balise_filter_assignment_all: "All",
    balise_filter_assignment_assigned: "Assigned",
    balise_filter_assignment_unassigned: "Unassigned",
    balise_filter_brand: "Brand",
    balise_filter_brand_all: "All brands",
    balise_col_lock_code: "Lock code",
    balise_col_brand: "Brand",
    balise_col_battery: "Battery",
    balise_col_status: "Status",
    balise_col_customer: "Customer",
    balise_col_actions: "Actions",
    balise_action_assign: "Assign",
    balise_action_unassign: "Unassign",
    balise_action_view_details: "View details",
    balise_pagination_page: "Page {{page}} of {{total}}",
    balise_pagination_prev: "Previous",
    balise_pagination_next: "Next",
    balise_no_balises: "No balises found",
    balise_load_failed: "Failed to load balises",
    balise_stats_failed: "Failed to load statistics",
    balise_commands_select: "Select balise",
    balise_commands_seal: "Seal",
    balise_commands_unseal: "Unseal",
    balise_commands_change_mode: "Change device mode",
    balise_mode_normal: "Normal",
    balise_mode_trip: "Trip mode",
    balise_mode_maxvision_only: "Device mode is only available for MaxVision devices.",
    balise_commands_select_first: "Select a balise first",
    balise_sync_select_lock: "Lock code",
    balise_sync_select_placeholder: "Select lock code",
    balise_sync_status_title: "Sync status",
    balise_sync_history_title: "Sync history",
    balise_sync_activate: "Activate",
    balise_sync_deactivate: "Deactivate",
    balise_sync_maintain: "Maintain",
    balise_sync_load: "Load sync data",
    balise_sync_loading: "Loading sync…",
    balise_sync_no_selection: "Select a lock code to view sync status",
    balise_decom_select: "Select balise to decommission",
    balise_decom_warning: "Decommissioning is permanent. The device will be removed from active inventory and cannot be undone.",
    balise_decom_confirm: "Decommission device",
    balise_decom_confirm_prompt: "Type the lock code to confirm: {{code}}",
    balise_assign_modal_title: "Assign to customer",
    balise_assign_container_modal_title: "Assign to container",
    balise_search_container_placeholder: "Search by code, type, owner, status…",
    balise_container_count: "{{n}} containers",
    balise_no_match_containers: "No containers match your search.",
    balise_assign_customer_id: "Customer ID",
    balise_assign_customer_name: "Customer name",
    balise_assign_customer_id_placeholder: "Numeric customer ID",
    balise_assign_customer_name_placeholder: "Display name",
    balise_details_title: "Balise details",
    balise_field_universal_id: "Universal ID",
    balise_field_device_name: "Device name",
    balise_field_last_seen: "Last seen",
    balise_field_assignment: "Assignment",
    balise_battery_unknown: "Unknown",
    balise_status_unknown: "Unknown",
    balise_customer_unassigned: "Unassigned",
    balise_action_in_progress: "Working…",
    balise_unassign_confirm: "Unassign this balise from its customer?",
    balise_assign_success: "Balise assigned successfully",
    balise_assign_failed: "Failed to assign balise",
    balise_unassign_success: "Balise unassigned",
    balise_unassign_failed: "Failed to unassign balise",
    balise_seal_success: "Seal command sent. The lock closes when the device answers.",
    balise_seal_failed: "Seal command failed",
    balise_unseal_success: "Unseal command sent. The lock opens when the device answers.",
    balise_unseal_failed: "Unseal command failed",
    balise_mode_success: "Device mode updated",
    balise_mode_failed: "Failed to change device mode",
    balise_sync_action_success: "Sync action completed",
    balise_sync_action_failed: "Sync action failed",
    balise_decom_success: "Balise decommissioned",
    balise_decom_failed: "Decommission failed",
    balise_decom_mismatch: "Lock code does not match",
    balise_decom_reason: "Reason",
    balise_decom_reason_placeholder: "Reason for decommissioning…",
    balise_decom_confirm_title: "Decommission balise",
    balise_decom_confirm_msg_v2: "Decommission {{id}}? This is permanent.",
    balise_error_generic: "Something went wrong",
    balise_refresh_list: "Refresh list",
    // 9-button row + new dialogs (legacy parity)
    balise_action_sim: "Manage SIM",
    balise_action_trajectory: "Trajectory",
    balise_assign_modal_title_v2: "Assign balise",
    balise_assign_modal_subtitle: "Pick a container or an asset.",
    balise_assign_card_containers: "Available containers",
    balise_assign_card_assets: "Available assets",
    balise_assign_card_create: "Create new asset or container",
    balise_assign_create_hint: "No suitable target above? Open the Customer Management window to create a new asset or container, then come back to assign.",
    balise_assigned_short: "Balise",
    balise_no_assets: "No assets available",
    balise_no_match_assets: "No assets match your search.",
    balise_search_asset_placeholder: "Search by name, type, identifier, location…",
    balise_assign_confirm_title: "Confirm assignment",
    balise_assign_confirm_container: "This balise will be assigned to the selected container.",
    balise_assign_confirm_asset: "This balise will be assigned to the selected asset.",
    balise_assign_button: "Assign",
    balise_unassign_confirm_title: "Confirm unassignment",
    balise_unassign_confirm_msg_v2: "Unassign {{id}} from {{name}}?",
    balise_unassign_checking_sync: "Checking sync status…",
    sync_stop_message: "Sync is currently ACTIVE for {{id}}. What should happen?",
    sync_stop_keep: "Keep sync, unassign",
    sync_stop_stop: "Stop sync, unassign",
    sync_widget_title: "Data sync",
    sync_widget_refresh: "Refresh sync status",
    sync_widget_refresh_short: "Refresh",
    sync_widget_unavailable: "Sync status is unavailable for this balise.",
    sync_widget_activated_at: "Activated",
    sync_widget_maintained_at: "Maintained",
    detail_card_device: "Device information",
    detail_card_assignment: "Assignment",
    detail_card_technical: "Technical",
    detail_card_location: "Location",
    detail_field_container_id: "Container ID",
    detail_field_asset_id: "Asset ID",
    detail_field_coords: "Coordinates",
    detail_location_hint: "Use the GPS or Trajectory row icons to view on a map.",
    detail_location_none: "No GPS data available yet.",
    balise_field_device_type: "Device type",
    // SIM picker (replaces legacy "coming soon" toast)
    sim_assign_modal_title: "Manage SIM",
    sim_assign_pick: "Pick a SIM to assign to this balise.",
    sim_assign_pick_replacement: "Pick a replacement SIM, or detach the current one.",
    sim_assign_search_placeholder: "Search by ICCID, phone, operator, country…",
    sim_assign_count: "{{n}} SIM cards",
    sim_assign_load_failed: "Failed to load SIM cards",
    sim_assign_none: "No available SIM cards.",
    sim_assign_no_match: "No SIM matches your search.",
    sim_assign: "Assign SIM",
    sim_replace: "Replace SIM",
    sim_assign_success: "SIM assigned to balise",
    sim_assign_failed: "Failed to assign SIM",
    sim_unassign_success: "SIM detached from balise",
    sim_unassign_failed: "Failed to detach SIM",
    sim_current_label: "Currently attached",
    sim_current_badge: "Current",
    sim_data_left: "{{used}}/{{limit}} MB",
    sim_detach: "Detach",
    // Map modal (Location + Trajectory)
    map_modal_title_location: "GPS location",
    map_modal_title_trajectory: "Trajectory",
    map_modal_tab_location: "Location",
    map_modal_tab_trajectory: "Trajectory",
    map_modal_copy: "Copy",
    map_modal_copy_coords: "Copy coordinates",
    map_modal_open_external: "Open in Google Maps",
    map_modal_iframe_title: "Map preview",
    map_modal_iframe_failed: "Map failed to load",
    map_modal_no_coords: "No GPS coordinates for this balise yet.",
    map_modal_no_trajectory: "No trajectory data found for this period.",
    map_modal_no_data: "No trajectory data available for this device.",
    map_modal_loading_trajectory: "Loading trajectory…",
    map_modal_widened_window: "No data for {{requested}} — showing {{used}} instead.",
    map_modal_has_data_elsewhere: "No data in {{requested}}. Device has {{n}} points overall — try a wider window.",
    map_modal_fix_at: "Fix at",
    map_modal_open_in_tracking: "Open in Fleet Map",
    map_modal_open_in_tracking_unassigned: "This balise is not assigned to an asset — nothing to show on the Fleet Map.",
    cockpit_title: "Vehicle cockpit",
    cockpit_title_bound: "Cockpit — {{name}}",
    cockpit_subtitle: "All balises and captors attached to this asset",
    cockpit_empty: "No balise or captor is assigned to this vehicle yet. Assign one in Balise Management.",
    cockpit_no_binding: "Select a vehicle and open its cockpit to see balises and captors.",
    cockpit_select_vehicle: "Select a vehicle first",
    cockpit_captors: "Captors & IO",
    cockpit_ble: "BLE sensors (EYE / tags)",
    map_modal_range_1h: "Last hour",
    map_modal_range_6h: "Last 6 hours",
    map_modal_range_24h: "Last 24 hours",
    map_modal_range_3d: "Last 3 days",
    map_modal_range_7d: "Last week",
    map_modal_range_30d: "Last month",
    map_modal_range_3m: "Last 3 months",
    map_modal_stat_points: "Points",
    map_modal_stat_avg_speed: "Avg speed",
    map_modal_stat_max_speed: "Max speed",
    map_modal_stat_window: "Window",

    // Asset & Container Modal (acm)
    acm: {
      assetsAndContainers: "Assets & Containers",
      containers: "Containers",
      assets: "Assets",
      balises: "balise(s)",
      add: "Add",
      noContainers: "No containers yet",
      noAssets: "No assets yet",
      addContainer: "Add Container",
      editContainer: "Edit Container",
      addAsset: "Add Asset",
      editAsset: "Edit Asset",
      reference: "Equipment Reference",
      referenceRequired: "Equipment reference is required",
      type: "Container Type",
      status: "Status",
      owner: "Owner",
      origin: "Origin",
      destination: "Destination",
      bookingRef: "Booking Reference",
      assetName: "Asset Name",
      assetType: "Type",
      identifier: "Identifier",
      assetFieldsRequired: "Name and identifier are required",
      location: "Location",
      description: "Description",
      update: "Update",
      create: "Create",
      containerCreated: "Container created",
      containerUpdated: "Container updated",
      assetCreated: "Asset created",
      assetUpdated: "Asset updated",
      linked: "Linked",
      unlinked: "Unlinked",
      assigned: "Assigned",
      balisesFor: "Balises for",
      noBalises: "No balises found",
      cannotDelete: "Cannot Delete",
      unassignFirst: "Unassign all balises before deleting this container.",
      allUnassigned: "All balises unassigned!",
      proceedDelete: "Proceed with Delete",
      unassign: "Unassign",
      baliseUnassigned: "Balise unassigned",
      confirmDeleteTitle: "Confirm Delete",
      confirmDeleteMsg: "Delete {{type}} \"{{name}}\"? This cannot be undone.",
    },
    telemetryAlerts: {
      newRule: "New alert rule",
      editRule: "Edit alert rule",
      editorSubtitle: "Define the event, conditions, schedule, actions and scope.",
      trigger: "Trigger",
      triggerHint: "Choose the real event or sensor signal that starts this alert.",
      conditions: "Parameters and conditions",
      conditionsHint: "Set the threshold, persistence and optional location condition.",
      time: "Time",
      timeHint: "Always active by default. Add restrictions only when operationally necessary.",
      actions: "Actions and diffusion",
      actionsHint: "Choose notification channels and portal or external recipients.",
      appliesTo: "Applies to",
      appliesToHint: "Select the customer and operational scope. Unsupported targets are blocked.",
      general: "General",
      generalHint: "Name, explain and prioritize this operational rule.",
      operator: "Condition",
      value: "Value",
      delay: "Condition must persist",
      cooldown: "Repeat cooldown",
      eventExplainer: "This rule fires only when a verified vendor event is normalized to this signal.",
      locationRequired: "Location / trajectory *",
      locationOptional: "Only while inside a geofence (optional)",
      chooseOnMap: "Choose on map",
      zoneRequired: "Select at least one operational zone.",
      noLocationRestriction: "No location restriction.",
      scheduleEnabled: "Restricted schedule",
      alwaysActive: "Always active — 24/7",
      startDate: "Start date (optional)",
      endDate: "End date (optional)",
      timezone: "Timezone",
      from: "From",
      to: "To",
      portalRecipients: "Portal recipients",
      externalRecipients: "External recipients (no portal account required)",
      noPortalRecipients: "No portal users with email in this scope.",
      notConfigured: "Not configured",
      allCustomers: "All customers",
      selectFleet: "Select a fleet…",
      selectMission: "Select an active mission…",
      selectVehicleType: "Select vehicle type…",
      selectDeviceType: "Select device type…",
      allDevicesOfType: "All devices of this type",
      selected: "selected",
      noSignal: "No current signal",
      partial: "Partial coverage",
      noTargetData: "No current telemetry snapshot exists for this scope.",
      coverage: "{{supported}} of {{total}} target vehicles currently report this signal.",
      unsupportedScope: "The selected targets do not report this signal.",
      ruleName: "Rule name *",
      severity: "Severity",
      info: "Information",
      critical: "Critical",
      description: "Description",
      descriptionPlaceholder: "Explain the operational response expected when this alert fires.",
      liveSummary: "Rule summary",
      advancedBehavior: "Advanced behavior",
      repeatWhileActive: "Allow repeats while an alert remains active",
      notifyRecovery: "Notify recipients when values return to normal",
      createRule: "Create rule",
      ruleCreated: "Alert rule created",
      ruleUpdated: "Alert rule updated",
      saveFailed: "Failed to save the alert rule.",
      invalidRecipient: "Enter an email, HTTPS webhook URL, or international phone number.",
      zoneRefreshFailed: "The zone was saved but the list could not be refreshed.",
      drawGeofence: "Draw a new geofence",
      drawTrajectory: "Draw a new trajectory",
      selectGeofences: "Select geofences",
      selectTrajectories: "Select trajectories",
      newGeofence: "New geofence",
      newTrajectory: "New trajectory",
      categories: {
        LOCATION: "Location",
        DRIVING: "Driving",
        DEVICE_HEALTH: "Device health",
        SECURITY: "Security",
        ENVIRONMENT: "Environment",
        OBD: "OBD / vehicle",
        TAGS: "Tags / peripherals",
        LOGISTICS: "Logistics",
      },
      scope: {
        all: "All vehicles",
        fleet: "Fleet",
        vehicles: "Vehicles",
        mission: "Mission",
        vehicleType: "Vehicle type",
        deviceType: "Device / sensor",
      },
      days: { Sun: "Sun", Mon: "Mon", Tue: "Tue", Wed: "Wed", Thu: "Thu", Fri: "Fri", Sat: "Sat" },
      triggers: {
        GEOFENCE_ENTRY: "Zone entry",
        GEOFENCE_EXIT: "Zone exit",
        CORRIDOR_DEVIATION: "Trajectory deviation",
        DWELL_TIME: "Time in zone",
        STOPPED_TOO_LONG: "Stopped too long",
        SPEED_THRESHOLD: "Speed threshold",
        BATTERY_LOW: "Low battery",
        SIGNAL_LOW: "Weak signal",
        DEVICE_OFFLINE: "Device offline",
        GPS_SIGNAL_LOST: "GPS signal lost",
        LOW_BATTERY_EVENT: "Low-battery device alarm",
        POWER_LOSS: "External power lost",
        LOCK_STATE: "Lock or seal state",
        TAMPER: "Tamper detected",
        VIBRATION: "Vibration detected",
        SOS_PANIC: "SOS / panic",
        TEMPERATURE_THRESHOLD: "Temperature threshold",
        HUMIDITY_THRESHOLD: "Humidity threshold",
        IGNITION_STATE: "Ignition state",
        RPM_THRESHOLD: "Engine RPM",
        COOLANT_TEMPERATURE: "Coolant temperature",
        FUEL_LEVEL: "Low fuel level",
        ODOMETER_THRESHOLD: "Odometer threshold",
        DIAGNOSTIC_EVENT: "Diagnostic fault",
        TAG_BATTERY_LOW: "Tag battery low",
        TAG_TEMPERATURE: "Tag temperature",
        TAG_MISSING: "Tag missing",
      },
    },
    settings_tab_mail: "Mail center",
    communications: {
      title: "Platform mail center",
      description: "Configure platform delivery, transactional templates, and consent-aware newsletters.",
      sections: {
        smtp: "Mail server",
        smtpDescription: "Guided setup for your provider, sender identity and a delivery test.",
        branding: "Branding",
        brandingDescription: "Logo, colour and footer applied to every message.",
        templates: "Messages",
        templatesDescription: "Edit what each automatic e-mail says, in English and French.",
        newsletters: "Newsletters",
        newslettersDescription: "Build, schedule, and review platform campaigns.",
      },
      validation: {
        host: "Enter the SMTP hostname.",
        port: "Enter a port from 1 to 65535.",
        email: "Enter a valid email address.",
        smtpPassword: "A password is required when an SMTP username is configured.",
      },
      smtp: {
        configured: "Mail server configured",
        notConfigured: "Mail server not configured",
        completeSettings: "Complete and verify the SMTP settings below.",
        updated: "Updated",
        connected: "Configured",
        required: "Required",
        passwordStored: "Password stored",
        noPassword: "No password",
        host: "SMTP host",
        port: "SMTP port",
        username: "Username",
        password: "Password",
        replacePassword: "Replace password",
        keepPassword: "Leave blank to keep the stored password",
        senderName: "Sender name",
        senderAddress: "Sender address",
        replyTo: "Reply-To address",
        implicitTls: "Implicit TLS",
        tlsHint: "Enable for port 465; leave off for STARTTLS, commonly port 587.",
        saveVerify: "Save and verify connection",
        saved: "SMTP settings were verified and saved.",
        steps: {
          provider: "Provider",
          credentials: "Credentials",
          sender: "Sender",
        },
        chooseProvider: "Choose your mail provider.",
        beforeYouStart: "What you need from this provider",
        providerDocs: "Provider instructions",
        ownServer: "Your own server",
        showAdvanced: "Show host and port",
        hideAdvanced: "Hide host and port",
        usernameEmail: "Use the full e-mail address of the sending account.",
        usernameLogin: "Use the SMTP login supplied by the provider.",
        usernameFixed: "This provider requires this exact username.",
        senderNameHint: "The name recipients see in their inbox.",
        replyToHint: "Where replies are sent. Leave empty to use the sender address.",
        fixFields: "Correct the highlighted fields first.",
        back: "Back",
        next: "Continue",
        sendTest: "Send a delivery test",
        testHint: "Uses the saved SMTP connection and SMTP test template.",
        verifyDelivery: "Send test",
        testSent: "Test email sent.",
      },
      mailErrors: {
        MAIL_UNCONFIGURED: {
          title: "Mail server is not configured",
          message: "Configure an SMTP host, sender address, and credentials before sending email.",
          suggestion1: "Enter the SMTP settings supplied by your mail provider.",
          suggestion2: "Save the settings, then run the test again.",
        },
        MAIL_DNS_FAILED: {
          title: "SMTP host was not found",
          message: "The SMTP hostname could not be resolved.",
          suggestion1: "Check the hostname for typing errors.",
          suggestion2: "Confirm that DNS is available from the Fleet API server.",
        },
        MAIL_CONNECTION_REFUSED: {
          title: "SMTP connection was refused",
          message: "The server was reached but is not accepting SMTP connections on this port.",
          suggestion1: "Confirm the SMTP port.",
          suggestion2: "Check provider firewall or IP allow-list rules.",
        },
        MAIL_CONNECTION_TIMEOUT: {
          title: "SMTP connection timed out",
          message: "The mail server did not answer in time.",
          suggestion1: "Check network and firewall access.",
          suggestion2: "Confirm the host and port with the provider.",
        },
        MAIL_TLS_MISMATCH: {
          title: "SMTP encryption setting does not match",
          message: "The selected TLS mode is not supported on this SMTP port.",
          suggestion1: "Use implicit TLS for port 465.",
          suggestion2: "Use STARTTLS for port 587.",
        },
        MAIL_CERTIFICATE_INVALID: {
          title: "SMTP certificate could not be verified",
          message: "The mail server presented an invalid or untrusted certificate.",
          suggestion1: "Confirm the hostname matches the certificate.",
          suggestion2: "Ask the provider to repair the certificate chain.",
        },
        MAIL_AUTH_FAILED: {
          title: "SMTP authentication failed",
          message: "The mail server rejected the username or password.",
          suggestion1: "Re-enter the SMTP username and password.",
          suggestion2: "Use an app password if the provider requires one.",
        },
        MAIL_SENDER_REJECTED: {
          title: "Sender address was rejected",
          message: "The SMTP server does not permit this sender or relay.",
          suggestion1: "Use a verified sender address.",
          suggestion2: "Confirm relay permissions for the SMTP account.",
        },
        MAIL_RECIPIENT_REJECTED: {
          title: "Recipient address was rejected",
          message: "The SMTP server refused the recipient address.",
          suggestion1: "Check the recipient address.",
          suggestion2: "Confirm the recipient domain accepts mail.",
        },
        MAIL_RATE_LIMITED: {
          title: "Mail provider rate limit reached",
          message: "The provider temporarily limited email delivery.",
          suggestion1: "Wait before retrying.",
          suggestion2: "Review the provider sending quota.",
        },
        MAIL_TEMPORARY_FAILURE: {
          title: "Mail provider is temporarily unavailable",
          message: "The provider returned a temporary SMTP failure.",
          suggestion1: "Retry later.",
          suggestion2: "Check the provider status page.",
        },
        MAIL_VALIDATION_FAILED: {
          title: "Mail settings are invalid",
          message: "Correct the highlighted settings and try again.",
          suggestion1: "Review every required field.",
          suggestion2: "Confirm sender and reply-to addresses are valid.",
        },
        MAIL_UNKNOWN: {
          title: "Mail delivery failed",
          message: "The mail server could not complete the request.",
          suggestion1: "Review the SMTP settings.",
          suggestion2: "Ask a server administrator to inspect the Fleet API logs.",
        },
      },
      categories: {
        ACCOUNT: "Account",
        SECURITY: "Security",
        ALERT: "Fleet alerts",
        NEWSLETTER: "Newsletter",
        SYSTEM: "System",
      },
      blocks: {
        empty: "This message has no content yet. Add a block below.",
        insertData: "Insert data",
        insertHint: "Click inside a text field, then add a value that is filled in when the message is sent.",
        addItem: "Add a bullet",
        addRow: "Add a line",
        factLabel: "Label",
        factValue: "Value",
        codeLabel: "Label above the code",
        codeValue: "Code",
        buttonLabel: "Button text",
        dividerHint: "Draws a separating line.",
        imageUrl: "Image address (https://…)",
        imageAlt: "Description for readers who cannot see it",
        imageCaption: "Caption (optional)",
        imageLink: "Open this address when clicked (optional)",
        imageHint: "Paste the web address of an image hosted online.",
        moveUp: "Move up",
        moveDown: "Move down",
        remove: "Remove",
        types: {
          paragraph: "Text",
          bullets: "Bullet list",
          callout: "Highlight",
          code: "Large code",
          facts: "Detail list",
          button: "Button",
          image: "Image",
          divider: "Separator",
        },
        tones: {
          info: "Neutral",
          success: "Positive",
          warning: "Caution",
          critical: "Urgent",
        },
      },
      templates: {
        events: "Event templates",
        empty: "No email templates are available.",
        enabled: "Enabled",
        disabled: "Turned off",
        savedPreviewHint: "Preview and test use the saved version.",
        subject: "Subject",
        heading: "Title inside the message",
        preheader: "Inbox summary line",
        preheaderHint: "Shown next to the subject in most inboxes. Keep it under 90 characters.",
        body: "Message body",
        content: "Message content",
        contentHint: "Build the message from blocks. The preview on the right updates as you type.",
        layout: "Layout",
        layoutHint: "Choose how this message is presented.",
        actionLabel: "Action button label",
        actionLabelEmpty: "Leave empty for no button",
        toggleTheme: "Switch between light and dark mode",
        saveBeforeTest: "Save your changes before sending a test.",
        testHint: "Sends this message with sample data, using the saved version.",
        variables: "Available variables",
        variableHint: "Choose a destination field, then insert a safe variable.",
        reset: "Reset default",
        resetConfirm: "Reset this language to the platform default?",
        resetDone: "Template reset to its default.",
        resetFailed: "Template could not be reset.",
        save: "Save template",
        saved: "Template saved.",
        saveFailed: "Template could not be saved.",
        preview: "Preview",
        previewSubject: "Rendered subject",
        previewFailed: "Template preview failed.",
        saveBeforePreview: "Save changes before previewing.",
        sendTest: "Send selected-template test",
        send: "Send test",
        testSent: "Template test sent.",
        testFailed: "The template test could not be sent.",
        loadFailed: "Email templates could not be loaded.",
      },
      branding: {
        intro: "These settings appear in every message the platform sends.",
        appName: "Platform name",
        appNameHint: "Used in subjects, buttons and the footer.",
        logoUrl: "Logo address",
        logoUrlHint: "A public https address to a PNG or JPEG. Leave empty to show the name as text.",
        accent: "Main colour",
        accentHint: "Used for buttons and highlights.",
        theme: "Appearance",
        themeHint: "Dark mode keeps light text on a dark background in every message.",
        themes: { LIGHT: "Light", DARK: "Dark" },
        supportEmail: "Support address",
        supportEmailHint: "Shown in the footer so recipients know where to ask for help.",
        footerNote: "Footer note",
        footerNoteHint: "For example, why the recipient is receiving this message.",
        postalAddress: "Postal address",
        postalAddressHint: "Required by anti-spam rules for newsletters.",
        preview: "Live preview",
        save: "Save branding",
        saved: "Branding saved.",
        saveFailed: "Branding could not be saved.",
        loadFailed: "Branding could not be loaded.",
      },
      variables: {
        appName: "Platform name",
        appUrl: "Platform web address",
        recipientName: "Recipient display name",
        invitationUrl: "Invitation acceptance link",
        resetUrl: "Password reset link",
        verificationUrl: "Email verification link",
        unsubscribeUrl: "Signed unsubscribe link",
        actionUrl: "Primary action link",
        expiresIn: "Link or code validity",
        code: "Single-use verification code",
        changedAt: "Password change date and time",
        event: "Security event description",
        eventAt: "Security event date and time",
        ipAddress: "Source IP address",
        newEmail: "Pending email address",
        status: "New account status",
        changedBy: "Administrator who made the change",
        alertType: "Fleet alert type",
        vehicleCode: "Vehicle identifier",
        severity: "Alert severity",
        message: "Alert message",
        observed: "Observed alert value",
        position: "Vehicle position",
        sentAt: "Test send date and time",
        newsletterSubject: "Campaign subject",
        newsletterContent: "Campaign content",
      },
      newsletters: {
        new: "New campaign",
        empty: "No campaigns yet.",
        loadFailed: "Newsletter campaigns could not be loaded.",
        draftHint: "Draft — nothing is sent until you send or schedule it.",
        campaignName: "Campaign name",
        namePlaceholder: "October customer update",
        nameHint: "Only you see this name; recipients see the subject.",
        design: "Design",
        designHint: "Pick a look, then write the content.",
        primaryLanguage: "Main language",
        optional: "Optional",
        addLanguage: "Add {{language}}",
        switchPrimary: "Write in {{language}} instead",
        fallbackHint: "Leave this language empty and its recipients receive the {{language}} version.",
        subject: "Subject",
        subjectPlaceholder: "What this message is about",
        content: "Content",
        button: "Button",
        buttonHint: "Optional. A single call to action under the content.",
        buttonLabel: "Button text",
        buttonUrl: "Button address",
        preheader: "Inbox preview text",
        preheaderHint: "The line shown after the subject in most inboxes.",
        nameRequired: "Give the campaign a name.",
        subjectRequired: "Write a subject in the campaign language.",
        contentRequired: "Add some content in the campaign language.",
        ctaUrlRequired: "The button needs an address starting with http or https.",
        previewEmpty: "The preview appears once there is a subject and some content.",
        sendNow: "Send now",
        sendNowConfirm: "Send this campaign to about {{count}} recipient(s) now?",
        sendingCount: "Sending to {{count}} recipient(s).",
        scheduleAt: "Delivery date and time",
        everyone: "Everyone eligible",
        chosenCustomers: "Only chosen customers",
        refine: "Refine sources and languages",
        languagesHint: "Recipients in unchecked languages are skipped entirely.",
        tabs: {
          campaigns: "Campaigns",
          contacts: "Contacts",
        },
        stats: {
          subscribed: "Subscribed",
          unsubscribed: "Unsubscribed",
          suppressed: "Suppressed",
          knownContacts: "Known contacts",
        },
        columns: {
          campaign: "Campaign",
          design: "Design",
          target: "Target",
          status: "Status",
          delivery: "Delivered",
          when: "Date",
        },
        edit: "Edit",
        view: "Open",
        delete: "Delete draft",
        deleted: "Draft deleted.",
        deleteConfirm: "Delete this draft?",
        cancelConfirm: "Stop this campaign? Recipients not yet reached are cancelled.",
        deliveryLog: "Delivery log",
        noRecipients: "No recipients recorded.",
        rowCount: "{{count}} entry/entries",
        failedCount: "{{count}} failed",
        retryFailed: "Retry failed addresses",
        retried: "Failed addresses queued again.",
        searchContacts: "Search an address, a name or a company",
        consent: "Subscriptions",
        consentStatus: {
          SUBSCRIBED: "Subscribed",
          UNSUBSCRIBED: "Unsubscribed",
        },
        consentUpdated: "Subscription updated.",
        unsubscribeAction: "Unsubscribe",
        resubscribeAction: "Resubscribe",
        noSubscriptions: "No subscription recorded yet.",
        approvals: "Contact approvals",
        approvalsHint: "Customer and staff contacts only receive campaigns once approved.",
        approved: "Approved",
        notApproved: "Not approved",
        approve: "Approve",
        revoke: "Revoke",
        approvalUpdated: "Approval updated.",
        noContacts: "No contact found.",
        contactType: {
          CUSTOMER: "Customer",
          STAFF: "Staff",
        },
        suppressions: "Suppressed addresses",
        suppressionsHint: "Addresses that bounced or were blocked; they are never contacted.",
        suppressionRemoved: "Address removed from the suppression list.",
        noSuppressions: "No suppressed address.",
        contactsLoadFailed: "Contacts could not be loaded.",
        variables: {
          recipientName: "Recipient name",
          appName: "Application name",
          unsubscribeUrl: "Unsubscribe link",
        },
        audience: "Audience",
        approvedHint: "Suppressed and unsubscribed addresses are excluded automatically.",
        sources: "Recipient sources",
        source: {
          PORTAL_USERS: "Active portal users",
          CUSTOMER_CONTACTS: "Customer contacts",
          STAFF_CONTACTS: "Active staff contacts",
        },
        approvedOnly: "Only explicitly approved contacts are eligible.",
        languages: "Recipient languages",
        selectedCustomers: "{{count}} customer(s) selected.",
        estimated: "{{count}} eligible · EN {{en}} · FR {{fr}}",
        estimating: "Estimating eligible recipients…",
        saveDraft: "Save draft",
        saved: "Campaign saved.",
        saveFailed: "Campaign could not be saved.",
        discardConfirm: "Discard unsaved campaign changes?",
        preview: "Preview",
        preferencesLink: "Manage email preferences",
        clone: "Clone",
        cloned: "Campaign cloned as a new draft.",
        archive: "Archive",
        archived: "Campaign archived.",
        test: "Test delivery",
        send: "Send test",
        testHint: "The test is saved as a draft first, so it matches exactly what recipients get.",
        testSent: "Newsletter test sent.",
        testFailed: "Newsletter test could not be sent.",
        previewFailed: "The preview could not be rendered.",
        schedule: "Schedule",
        scheduleAction: "Schedule",
        invalidSchedule: "Choose a valid delivery date and time.",
        scheduledCount: "Campaign scheduled for {{count}} recipient(s).",
        emptyAudience: "No eligible recipients match this audience.",
        cancelAction: "Cancel campaign",
        cancelled: "Campaign cancelled.",
        reportFailed: "The delivery log could not be loaded.",
        actionFailed: "The campaign action could not be completed.",
        status: {
          DRAFT: "Draft",
          SCHEDULED: "Scheduled",
          SENDING: "Sending",
          SENT: "Sent",
          CANCELLED: "Cancelled",
          ARCHIVED: "Archived",
        },
      },
      recovery: {
        backToLogin: "Back to sign in",
        forgotTitle: "Reset your password",
        forgotDescription: "Enter your account email or username.",
        emailOrUsername: "Email or username",
        sendLink: "Send reset link",
        checkInbox: "Check your inbox",
        genericForgot: "If an active account matches those details, a password reset link has been sent.",
        requestFailed: "The request could not be completed. Please try again.",
        resetTitle: "Choose a new password",
        resetDescription: "Use a strong, unique password for your Fleet account.",
        newPassword: "New password",
        confirmPassword: "Confirm password",
        passwordInvalid: "The password does not meet every requirement.",
        invalidResetLink: "This reset link is invalid, expired, or already used.",
        resetFailed: "The password could not be reset.",
        resetAction: "Reset password",
        resetDone: "Password reset",
        resetDoneHint: "Earlier sessions were invalidated. You can now sign in.",
        signIn: "Sign in",
        policy: {
          lengthMin: "At least 12 characters",
          lengthMax: "At most 128 characters",
          lowercase: "Lowercase letter",
          uppercase: "Uppercase letter",
          number: "Number",
          symbol: "Symbol",
          match: "Passwords match",
        },
      },
      verification: {
        loadingTitle: "Verifying your email",
        loadingDescription: "Please wait while the secure link is checked.",
        doneTitle: "Email verified",
        doneDescription: "Your email address has been confirmed.",
        errorTitle: "Verification link unavailable",
        errorDescription: "This link is invalid, expired, or already used.",
        profileTitle: "Email verification",
        profileUnknown: "Request a link to verify this account email or confirm its current status.",
        profileSent: "A verification link was sent to your email address.",
        profileVerified: "Your email address is verified.",
        pendingEmail: "Pending verification: {{email}}",
        currentPassword: "Current password",
        passwordRequired: "Enter your current password to confirm this email change.",
        send: "Send verification link",
        resend: "Resend verification link",
        sent: "Verification email sent.",
        alreadyVerified: "Your email address is already verified.",
        sendFailed: "The verification email could not be sent.",
      },
      preferences: {
        title: "Newsletter preferences",
        description: "Use the signed link below to stop future platform newsletters for this address.",
        unsubscribe: "Unsubscribe from newsletters",
        doneTitle: "Unsubscribed",
        doneDescription: "This address will no longer receive platform newsletters.",
        invalidTitle: "Preference link unavailable",
        invalidDescription: "This signed link is invalid or expired.",
      },
    },
    access: {
      customerUsers: "Customer users",
      fleetTeam: "Fleet team",
      customerAccount: "Customer account",
      fleetAccount: "Fleet-team account",
      platformAdmin: "Platform administrator",
      globalScope: "Global scope",
      selectedScope: "Selected customers",
      allScopes: "All scopes",
      locked: "Locked",
      roleTemplate: "Role template",
      multiWorkspace: "{{count}} workspaces",
      users: {
        portalOnlyHint: "Portal access accounts only. Operational staff remain separate in Staff Management.",
        revokeConfirm: "Revoke access for {{username}}?",
        revoked: "User access revoked."
      },
      invitations: {
        title: "Invitations",
        resend: "Resend invitation",
        revoke: "Revoke invitation",
        revokeConfirm: "Revoke the pending invitation for {{username}}?",
        revoked: "Invitation revoked."
      },
      roles: {
        title: "Roles and capabilities",
        platformAdminHint: "Define protected and custom templates for customer and Fleet-team accounts.",
        tenantAdminHint: "View approved customer roles. Only platform administrators can define templates.",
        create: "Create role",
        edit: "Edit role",
        clone: "Clone role",
        archive: "Archive role",
        system: "Protected",
        custom: "Custom",
        archivedLabel: "Archived",
        assignments: "{{count}} assigned",
        noDescription: "No description provided.",
        none: "No roles in this family.",
        select: "Select a role to preview its effective access.",
        protectedHint: "This is a protected system role. Its identity cannot be renamed, archived, or deleted.",
        dangerousWarning: "This access includes sensitive administration capabilities. Review it carefully before assigning.",
        effectivePreview: "Effective access preview",
        noCapabilities: "This role grants no capabilities.",
        editorHint: "Capabilities selected here become the template's effective access.",
        internalName: "Internal name",
        displayName: "Display name",
        family: "Account family",
        copySuffix: "copy",
        required: "Internal and display names are required.",
        saved: "Role saved.",
        archived: "Role archived.",
        deleted: "Role deleted.",
        loadFailed: "Roles could not be loaded.",
        saveFailed: "Role could not be saved.",
        archiveConfirm: "Archive {{name}}? Existing assignments remain in place.",
        deleteConfirm: "Permanently delete {{name}}?"
      },
      wizard: {
        type: "User type",
        identity: "Identity",
        scope: "Data scope",
        role: "Role templates",
        platforms: "Platform access",
        overrides: "Advanced overrides",
        review: "Review",
        step: "Step {{current}} of {{total}}",
        customerTypeHint: "A customer account with one or more workspace memberships.",
        fleetTypeHint: "An internal Fleet-team account with global or selected-customer scope.",
        platformAdminCurrent: "This existing account is an unrestricted superuser, separate from role templates.",
        platformAdminUnsupported: "Superuser promotion is intentionally unavailable here because the current API does not expose that operation.",
        platformAdminRoleHint: "Platform administrators have unrestricted access. No role template or capability override applies.",
        tenantIdentityLocked: "Tenant administrators cannot change global identity fields.",
        globalHint: "Access every current and future customer without individual memberships.",
        selectedHint: "Limit access to an explicit list of customers.",
        chooseRole: "Choose an approved role",
        roleRequired: "Choose a valid role template for every required scope.",
        otherPlatformsAdminOnly: "Only platform administrators can grant access to other platforms.",
        enableOverrides: "Customize capabilities",
        overrideHint: "Optional: add or remove individual capabilities from the selected role. Changes are highlighted.",
        added: "Added",
        removed: "Removed"
      }
    },
  }
}

export default en
